import React, { FC, memo } from 'react';

import AdminListFieldTab from './AdminListFieldTab';

const Source: FC = () => (
  <AdminListFieldTab
    fieldName="information_sources"
    commentFieldName="comment_information_sources"
    noteId="expert-note-source"
    titleKey="tab_sources"
    hintKey="tab_sources_hint"
  />
);

export default memo(Source);
